<template>
    <div class="pop-up-events-calendar" :style="style">
        <div class="header">
            <p class="title">{{ title }}</p>
            <i class="fa-regular fa-xmark" @click="$emit('close')"></i>
        </div>
        <div class="events-list" :style="{ maxHeight: style.maxHeight }">
            <div 
                v-for="event in events" 
                :key="event.id" 
                class="event-item"
            >
                <Event 
                    v-bind="event"
                    :isPlaceholder="eventDragged.eventId === event.id"
                    :isDraggable="event.editable !== false"
                    v-on="$listeners"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import ClickOutside from 'vue-click-outside'
    import Event from './Event.vue'
import { max } from 'moment';
    export default {
        components: {
            Event,
        },
        directives: {
            ClickOutside
        },
        props: {
            containerRef: {
                type: Object,
                required: true,
            },
            anchorRef: {
                type: Object,
                required: true,
            },
            events: {
                type: Array,
                default: () => []
            },
            eventDragged: {
                type: Object,
                default: () => ({})
            },
            title: String
        },

        data() {
            return {
                style: {
                    top: `0px`,
                    left: `0px`,
                    visibility: 'hidden'
                }
            }
        },
        mounted () {
            setTimeout(() => {
                window.addEventListener("click", this.handleClickOutside);
            }, 200);
        },

        methods: {
            updatePosition() {
                this.$nextTick(() => {
                    if (!this.anchorRef || !this.containerRef || !this.$el) return;
                    const OFFSET = 0
                    const anchorRect = this.anchorRef.getBoundingClientRect();
                    const containerRect = this.containerRef.getBoundingClientRect();
                    
                    // On récupère les dimensions RÉELLES après le rendu
                    const popUpWidth = this.$el.offsetWidth;
                    const popUpHeight = this.$el.offsetHeight;

                    let top = anchorRect.top - containerRect.top;
                    let left = anchorRect.left - containerRect.left;

                    // Logique de collision (Clamping)
                    // On évite de sortir à droite
                    if (left + popUpWidth > containerRect.width) {
                        left = containerRect.width - popUpWidth - OFFSET;
                    }
                    // On évite de sortir en bas
                    if (top + popUpHeight > containerRect.height) {
                        top = containerRect.height - popUpHeight - OFFSET;
                    }
                    
                    // Sécurité minimum
                    left = Math.max(OFFSET, left);
                    top = Math.max(OFFSET, top);

                    this.style = {
                        top: `${top}px`,
                        left: `${left}px`,
                        visibility: 'visible', // On l'affiche une fois bien positionné
                        maxHeight: `${containerRect.height-60}px`,
      
                    };
                });
            },

            handleClickOutside(event) {
               
                const targetElement = this.$el;
        
                if (!targetElement.contains(event.target)) {
                    this.$emit('close')
                }
            },
        },

        watch: {
            events: {
                immediate: true,
                handler() {
                    this.updatePosition();
                }
            }
        },
        beforeDestroy () {
            window.removeEventListener("click", this.handleClickOutside);
        },
        
    }

   
</script>

<style lang="scss" scoped>
    .pop-up-events-calendar {
        position: absolute;
        background: #fff;
        border-radius: 10px;
        padding: 0 10px 10px 10px;
        box-shadow: rgba(0, 0, 0, 0.11) 0px 0px 6px;
        width: 240px;
        max-height: none !important;
        z-index: 20;
        .header {
            height: 35px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            p {
                color: #121826;
                font-size: 14px;
                font-weight: 500;
            }
            i {
                color: #666a73;
                height: 35px;
                width: 35px;
                display: flex;
                align-items: center;
                justify-content: center;
                position: absolute;
                top: 0;
                right: 0;
                cursor: pointer;
            }
        }
        .events-list {
            // height: 0;
            // flex-grow: 1;
            // padding: 0px 4px;
            // overflow-y: auto;
            display: flex;
            flex-direction: column;
            gap: 4px;
            overflow-y: auto;
        }
    }
</style>